import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, type JSX } from 'react';

import MarkdownCore from './MarkdownCore';
import remarkPreserveLegacyNewlines from './remarkPreserveLegacyNewlines';

export type Props = {
  className?: string;
  markdown: string;
};

const REMARK_PLUGINS = [remarkPreserveLegacyNewlines];

/**
 * Restores the inter-paragraph gap that the previous `MarkdownLabel` produced
 * via a `<p>&nbsp;</p>` filler element. `space-y-4` puts a 1rem `margin-top`
 * on every direct child after the first, so adjacent blocks (`<p>`, `<ul>`,
 * `<h2>`, …) keep a visible break while staying true to the parsed markdown
 * (no synthetic empty paragraphs).
 */
const BLOCK_SPACING_CLASS = 'space-y-4';

const MarkdownDisplay: FC<Props> = ({ className, markdown }): JSX.Element => {
  return (
    <div className={clstx(BLOCK_SPACING_CLASS, className)}>
      <MarkdownCore markdown={markdown} remarkPlugins={REMARK_PLUGINS} />
    </div>
  );
};

export default MarkdownDisplay;
